export default __webpack_public_path__ + "static/media/NeonHeader.8a95647e.jpg";